module.exports = __webpack_public_path__ + "static/media/man.c1895c58.svg";